/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconXxx = createReactComponent("xxx", "IconXxx", [
  ["path", { d: "M10 8l4 8", key: "svg-0" }],
  ["path", { d: "M10 16l4 -8", key: "svg-1" }],
  ["path", { d: "M17 8l4 8", key: "svg-2" }],
  ["path", { d: "M17 16l4 -8", key: "svg-3" }],
  ["path", { d: "M3 8l4 8", key: "svg-4" }],
  ["path", { d: "M3 16l4 -8", key: "svg-5" }]
]);

export { IconXxx as default };
//# sourceMappingURL=IconXxx.js.map
